import React from 'react';

type Props = {
  configuration?: any;
  children: React.ReactNode;
};

export function DatadogWrapper({ children }: Props) {
  return <>{children}</>;
}
